import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import { CheckIcon } from 'components/ReusableComponents/Icons/Check'
import { CrossIcon } from 'components/ReusableComponents/Icons/Cross'
import InfoIcon from 'components/ReusableComponents/Icons/Info'
import ReconciliationIcon from 'components/ReusableComponents/Icons/Reconciliation'
import { reconciliationCategoryNames } from 'main/reconciliationCategories'
import moment from 'moment'
import { useState } from 'react'
import invoiceApi from 'services/api/invoices'

import styles from './ReconciliationInfoCard.module.scss'

const ReconciliationInfoCard = ({
  reconciliation,
  className,
  onSetAsWontCharge,
  reloadResults
}) => {
  const [isRejectDialogVisible, setIsRejectDialogVisible] = useState(false)
  const [rejectionReason, setRejectionReason] = useState('')

  function handleCloseDialog() {
    setRejectionReason('')
    setIsRejectDialogVisible(false)
  }

  function handleSubmitDialog() {
    invoiceApi.reconciliation
      .evaluate({
        evaluateReason: rejectionReason,
        reconciliationId: reconciliation.reconciliationId
      })
      .then(() => {
        handleCloseDialog()
        reloadResults()
      })
      .catch(error => {
        console.warn(error.toString())
      })
  }

  if (isRejectDialogVisible) {
    return (
      <ConfirmationDialog
        title="Reject reconciliation request"
        hasDangerousAction
        positiveMessage="Reject request"
        negativeMessage="Cancel"
        onReject={handleCloseDialog}
        onConfirm={handleSubmitDialog}
        theme="blacklist"
      >
        <p className={styles.formLabel}>Reason of rejection</p>
        <textarea
          value={rejectionReason}
          onChange={e => setRejectionReason(e.target.value)}
          className={styles.textArea}
          placeholder="Explain rejection reason in detail"
        />
        <p className={styles.description}>
          <InfoIcon />
          An updated invoice will be sent to the customer.
        </p>
      </ConfirmationDialog>
    )
  }

  return (
    <div className={[className, styles.card].join(' ')}>
      <div className={styles.header}>
        <ReconciliationIcon className={styles.reconciliationIcon} />
        <hgroup className={styles.hgroup}>
          <p className={styles.category}>
            Category: {reconciliationCategoryNames[reconciliation.generateCategory]}
          </p>
        </hgroup>
      </div>

      <p className={styles.reason}>{reconciliation.generateReason}</p>

      <div className={styles.footer}>
        <div className={styles.added}>
          <p className={styles.addedBy}>
            Added by: <strong>{reconciliation.generatedByDashboardUserName}</strong>
          </p>
          <p className={styles.addedOn}>
            {moment(reconciliation.generatedOn).format('MMM DD, hh:MM A')}
          </p>
        </div>

        <div className={styles.buttons}>
          <button onClick={onSetAsWontCharge}>
            <CheckIcon /> Accept
          </button>
          <button onClick={() => setIsRejectDialogVisible(true)}>
            <CrossIcon /> Reject
          </button>
        </div>
      </div>
    </div>
  )
}

export default ReconciliationInfoCard
